import { Locale, type LocalizedString } from "../Locale.js";
import { WebMessageCareerPosition } from "../WebMessageCareerPosition.js";

export const webMessageCareerPositionNameMap: Record<WebMessageCareerPosition, LocalizedString> = {
	[WebMessageCareerPosition.Developer]: {
		[Locale.cs]: "Vývojář",
		[Locale.en]: "Developer",
	},
	[WebMessageCareerPosition.Manager]: {
		[Locale.cs]: "Manažer",
		[Locale.en]: "Manager",
	},
	[WebMessageCareerPosition.Tester]: {
		[Locale.cs]: "Tester",
		[Locale.en]: "Tester",
	},
	[WebMessageCareerPosition.GraphicDesigner]: {
		[Locale.cs]: "Grafik",
		[Locale.en]: "Graphic designer",
	},
};
